import { IDesignVariationsService } from 'shared/services/interface'
import config from 'config'
import { StringDictionary } from 'shared/types/util'

import { AbstractService } from 'shared/services/AbstractService'
import { SCENE_SOUCE } from '~/shared/constants'
import getLogger from 'shared/logger'
import { stringifyArrayFormatRepeat } from '~/shared/url'
import type { DesignVariations } from 'shared/types/gallery/design-variations'

const DEFAULT_DESIGN_VARIATIONS_QUERY = {} as DesignVariations.DesignVariationsQuery

export class DesignVariationsApi extends AbstractService implements IDesignVariationsService {
  public async getDesignVariations(query: DesignVariations.DesignVariationsQuery = DEFAULT_DESIGN_VARIATIONS_QUERY): Promise<DesignVariations.Response> {
    const {
      templateToken,
      locale,
      productKey,
      selectedOptions,
      variableOptions,
      variableAttributes,
      offset,
      limit,
      noCache,
      useConstraints,
      mpvId,
      sceneSource,
      searchBackend,
      designCreationTypes,
      variableTaxonomyIds,
      debug,
      scenePurpose,
      designPersonalizationContextId,
      customColorVariations,
    } = query

    const url = `v2/Designs/${templateToken}/Culture/${locale}/DesignVariations`
    const selectedOptionsObj: StringDictionary<string> = {}

    Object.entries(selectedOptions).forEach(([key, value]) => {
      const objKey = `selectedOptions[${key}]`

      selectedOptionsObj[objKey] = value
    })

    const { data } = await this.api.get<DesignVariations.Response>(url, {
      params: {
        productKey,
        offset,
        limit,
        variableOptions,
        variableAttributes,
        designCreationTypes,
        requestor: noCache ? config.noCacheRequestor : config.appName,
        noCache,
        useConstraints,
        mpvId,
        includeColorSwatches: true,
        includePreview: true,
        sceneSource: sceneSource ?? SCENE_SOUCE.SCENE_LOOKUP_SOURCED,
        searchBackend,
        variableTaxonomyIds,
        debug,
        scenePurpose,
        customColorVariations,
        ...(designPersonalizationContextId && { designPersonalizationContextId }),
        ...selectedOptionsObj,
      },
      paramsSerializer: stringifyArrayFormatRepeat,
    })

    return data
  }
}

export const DesignVariationsService = new DesignVariationsApi(config.services.designVariationsService, getLogger)
